$(document).ready(function() {
  $('.slider_wrap').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: true
  });
  $('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.slider_wrap',
    dots: false,
    focusOnSelect: true,
    infinite: false
  });
});
// show more / less

$(document).ready(function() {

 var box = $(".slider_text");
 var minimumHeight = 84; // max height in pixels
 var initialHeight = box.innerHeight();
 if (initialHeight > minimumHeight) {
    box.css('height', minimumHeight);
    $("#more").show();
 }
SliderReadMore();
function SliderReadMore() {
    $(".slider-btn").on('click', function () {
       var currentHeight = box.innerHeight();
       var autoHeight = box.css('height', 'auto').innerHeight();
       var newHeight = (currentHeight | 0) === (autoHeight | 0) ? minimumHeight : autoHeight;
      box.css('height', currentHeight).animate({
          height: (newHeight)
       })
       $('html, body').animate({
       });
      $(".slider-btn").toggle();
    });
 }
  var sliderInitialized = false;
      function initSlickSlider() {
        $('.sliderWrapper').slick({
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          responsive: [
            {
              breakpoint: 990,
              settings: {
                slidesToShow: 3,
                arrows: true,
                dots: false
              }
            }
          ]
        });
        sliderInitialized = true;
      }
      function destroySlickSlider() {
        $('.sliderWrapper').slick('unslick');
        sliderInitialized = false;
      }
      if ($(window).innerWidth() > 749) {
        initSlickSlider();
      }
      $(window).resize(function() {
        if ($(window).innerWidth() > 749 && !sliderInitialized) {
          initSlickSlider();
        } else if ($(window).innerWidth() <= 749 && sliderInitialized) {
          destroySlickSlider();
        }
      });
});

//Subscription code start 
$(document).ready(function() {

   // Get Frequancy value option 5
   $('#frequency input[type="radio"]').change(function() {
    var selectedValue = $(this).val();
    $('#delivery-frequancy').text(selectedValue);
    // $('input[name="properties[Roast Preference]"]').attr('value',selectedValue);
  });
  var initiallySelectedValue = $('#frequency input[type="radio"]:checked').val();
  $('#delivery-frequancy').text(initiallySelectedValue);

    // Get Roast Type value option 3
    $('#roast-preference input[type="radio"]').change(function() {
      var selectedValue = $(this).val();
      $('#roast-type-value').text(selectedValue);
      $('input[name="properties[Röstung]"]').attr('value',selectedValue);
    });
    var initiallySelectedValue = $('#roast-preference input[type="radio"]:checked').val();
    $('#roast-type-value').text(initiallySelectedValue);

    // Get Grind Type value Option 2
    $('#grind-type input[type="radio"]').change(function() {
      var selectedValue = $(this).val();
      $('#grind-type-value').text(selectedValue);
      $('input[name="properties[Zubereitung]"]').attr('value',selectedValue);
    });
    var initiallySelectedValue = $('#grind-type input[type="radio"]:checked').val();
    $('#grind-type-value').text(initiallySelectedValue);

    // Get Roast Type value option 1
    $('#coffee-type input[type="radio"]').change(function() {
      var selectedValue = $(this).val();
      $('#coffee-type-value').text(selectedValue);
        $('input[name="properties[Mahlgrad]"]').attr('value',selectedValue);
    });
    var initiallySelectedValue = $('#coffee-type input[type="radio"]:checked').val();
    $('#coffee-type-value').text(initiallySelectedValue);

  
    // Get Product variant value
    $('#bags input[type="radio"]').change(function() {
      var selectedValue = $(this).val();
      $('#product-variant-value').text(selectedValue);
      var variantPrice = $(this).siblings('label').find('.price').data('price');
      var compPrice = $(this).siblings('label').find('.price').data('compareprice');
      $('.get-price').text(variantPrice);
    });
    var initiallySelectedValue = $('#bags input[type="radio"]:checked').val();
    $('#product-variant-value').text(initiallySelectedValue);
    var variantPrice = $(this).siblings('label').find('.price').data('price');
    var compPrice = $(this).siblings('label').find('.price').data('compareprice');
    $('.get-price').text(variantPrice);

}); 
//Subscription code end
$(document).ready(function(){
  $(function () {
    $('.accordion  summary[aria-expanded="true"]').closest('.accordion').addClass('active-tab');
  });
  $('.accordion details').on('click',function(){
    $(this).attr('open');
    $(this).parent().addClass('active-tab');
    $(this).css("transition", "all 2s ease-in-out");
    $(this).children('.accordion__content').css("transition", "all 9s ease-in-out");
    $(this).parent('.accordion').siblings().find('details').removeAttr('open');
    $(this).parent('.accordion').siblings().removeClass('active-tab');
 });
 
 // Function to update the option values
  function updateOptionValues() {
    let optionValues = [];
    $('.gift-subscription .customvariants variant-selects .select__select').each(function(index) {
      optionValues.push($(this).val());
    });

    $('.gift-subscription .customSummary .selectedValue .optionOne').text(optionValues[0]);
    $('.gift-subscription .customSummary .selectedValue .optionTwo').text(optionValues[1]);
    $('.gift-subscription .customSummary .selectedValue .optionThree').text(optionValues[2]);
  }

  // Attach change event to all select elements
  $('.gift-subscription .customvariants variant-selects .select__select').change(function() {
    updateOptionValues();
  });

  // Initial call to set the values on page load
  updateOptionValues();
  // You can access each value by index: optionValues[0], optionValues[1], optionValues[2], etc. 


  if ($('#bags').hasClass('more-variants')) {
// Apply height for read more functioanlity
  let maxHeight = 0;
  // Loop through each .sub-select-card element
  
  $('.sub-select-card').each(function() {
      // Get the height of the current card
      const height = $(this).outerHeight();

      // Update maxHeight if the current height is greater
      if (height > maxHeight) {
          maxHeight = height;
      }
  });
  var newHeight = 5;
  newHeight = newHeight + maxHeight;
  $('#bags .box-option').css('max-height', + newHeight + 'px' );

  // Read more functioanlity
  $('.sub-builder #bags .read-more--wrapper .read-more span').text('Mehr?');

  // Handle click event
  $('.sub-builder #bags .read-more--wrapper .read-more span').on('click', function(event) {
    event.stopPropagation();
      if ($(this).text() === 'Mehr?') {
          $(this).text('Weniger').addClass('rotate');
          $('#bags .box-option').css('max-height', '100%' );
      } else {
          $(this).text('Mehr?').removeClass('rotate');
          $('#bags .box-option').css('max-height', + maxHeight + 'px' );
      }
  });
  }
 
    $('.gift-subscription .product-form__input select').on('change',function(){
      setTimeout(function(){
        $('.firstUnselect').text('Auswählen');
      },100);
    })
      

});